import { Link, useLocation } from 'react-router-dom';
import { Settings, LayoutDashboard, Pencil } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { useOrg } from '@/contexts/OrgContext';

const EDIT_PAGE_MAP: Record<string, string> = {
  '/':         '/admin/homepage',
  '/services': '/admin/services',
  '/about':    '/admin/about',
  '/contact':  '/admin/company-info',
  '/booking':  '/admin',
};

function getEditLink(pathname: string): string {
  if (EDIT_PAGE_MAP[pathname]) return EDIT_PAGE_MAP[pathname];
  if (pathname.startsWith('/p/')) return '/admin/page-builder';
  return '/admin';
}

export function AdminBar() {
  const { isOrgOwner, staffRole } = useAuth();
  const { isMarketingSite } = useOrg();
  const { pathname } = useLocation();

  // Only show for org owners/admins viewing their own tenant site
  if (!isOrgOwner && staffRole !== 'super_admin') return null;
  if (isMarketingSite) return null;

  const editLink = getEditLink(pathname);

  return (
    <div className="fixed top-0 left-0 right-0 z-[70] flex h-9 items-center justify-between bg-primary px-4 text-primary-foreground text-xs">
      <div className="flex items-center gap-1.5 font-medium opacity-80">
        <Settings className="h-3 w-3" />
        <span>Site owner view</span>
      </div>
      <div className="flex items-center gap-3">
        <Link
          to={editLink}
          className="flex items-center gap-1.5 rounded px-2 py-1 hover:bg-white/20 transition-colors font-medium"
        >
          <Pencil className="h-3 w-3" />
          Edit this page
        </Link>
        <Link
          to="/admin"
          className="flex items-center gap-1.5 rounded bg-white/20 px-2 py-1 hover:bg-white/30 transition-colors font-medium"
        >
          <LayoutDashboard className="h-3 w-3" />
          Admin dashboard
        </Link>
      </div>
    </div>
  );
}
